<script>
import { mapActions, mapState, mapGetters } from "vuex";
import NavigationWrapper from "@/components/NavigationWrapper";
import RemoveMemberModal from "@/pages/Team/Members/RemoveMemberModal";

export default {
  // Included components
  components: {
    NavigationWrapper,
    RemoveMemberModal,
  },

  data() {
    return {
      // Id of the role selected for the user
      roleId: null,

      // ID of the member
      memberId: null,
    };
  },

  computed: {
    // Options for the role dropdown
    roleOptions() {
      return Object.values(this.roles).map((role) => {
        return {
          text: role.name,
          value: role.id,
        };
      });
    },

    // The actual member object
    member() {
      return this.teamMembers[this.memberId];
    },

    // Mapped vuex state
    ...mapState(["roles", "teamMembers", "user"]),
    ...mapGetters(["activeRole", "can"]),
  },

  // When the component is created, fetch the team members and the role
  async created() {
    await Promise.all([
      this.getTeamMembers(
        "account.id,account.name,account.handle,account.email,role.name"
      ),
      this.getRoles("id,name"),
    ]);
    this.memberId = this.$route.params.memberId;
    this.roleId = this.member.role_id;
  },

  methods: {
    // When the form is submitted, change the member's role via the API
    async change() {
      this.putTeamMember({
        memberId: this.memberId,
        roleId: this.roleId,
      });
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["putTeamMember", "getTeams", "getTeamMembers", "getRoles"]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/team">Settings</b-breadcrumb-item>
      <b-breadcrumb-item to="/team/members">Members</b-breadcrumb-item>
      <b-breadcrumb-item active v-if="member">
        @{{ member.handle }}
      </b-breadcrumb-item>
    </template>
    <b-row class="mb-2" v-if="member">
      <b-col>
        <h1>{{ member.name || "@" + member.handle }}</h1>
      </b-col>
      <b-col
        align-self="center"
        v-if="can.members.edit && member.id != user.id"
      >
        <div class="float-right">
          <b-button variant="danger" v-b-modal.remove-modal>
            Remove Member
          </b-button>
          <RemoveMemberModal :member-id="memberId" modal-id="remove-modal" />
        </div>
      </b-col>
    </b-row>
    <b-card class="mb-3" v-if="member">
      <div>
        <b>Name</b>
        {{ member.name }}
      </div>
      <div>
        <b>Email</b>
        {{ member.email }}
      </div>
      <div>
        <b>Handle</b>
        @{{ member.handle }}
      </div>
    </b-card>
    <b-card v-if="member && can.roles.manage && member.id != user.id">
      <b-form id="role-form" @submit.stop.prevent="change">
        <b-form-group
          id="two-factor-code-group"
          label-for="two-factor-code"
          label="Role"
        >
          <b-form-select
            required
            id="role"
            v-model="roleId"
            :options="roleOptions"
          >
            <template #first>
              <option :value="null" disabled>Role</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-form>
      <b-button variant="primary" type="submit" form="role-form">
        Set Role
      </b-button>
    </b-card>
  </NavigationWrapper>
</template>

<style scoped></style>
